
<template>
    <aside class="shopping-basket">
        <div class="basket">
            <header>
                <div class="del" v-on:click="$root.closeBasket">Continue shopping <span class="icon-right"></span></div>
                <h2>My Basket</h2>
            </header>

            <template v-if="basket.items.length">
                <ul>
                    <li v-for="( item, index ) in basket.items" v-on:change="item.save()">
                        <router-link :to="{ name: 'photo', params: { photo_id: item.photo_id } }" class="preview"><img :src="`${ item.photo.url }.thumb.jpg`"/></router-link>

                        <div class="details">
                            <div>
                                <h3><router-link :to="{ name: 'photo', params: { photo_id: item.photo_id } }">{{ item.product.title }}</router-link></h3>
                                <p class="subheader" v-if="item.product.description">{{ item.product.description }}</p>
                            </div>

                            <dl>
                                <template v-if="item.product.dimensions">
                                    <dt>Dimensions:</dt>
                                    <dd>{{ item.product.dimensions }}</dd>
                                </template>

                                <dt><label :for="`item${ index }`">Quantity:</label></dt>
                                <dd><input type="number" v-model.number="item.quantity" min="1" :id="`item${ index }`"/></dd>
                            </dl>
                        </div>

                        <div class="cost">
                            <div class="del" v-on:click="basket.remove( item )">remove<span class="icon-cross"></span></div>

                            <span>{{ currency( item.total ) }}</span>
                        </div>
                    </li>
                </ul>

                <footer>
                    <dl>
                        <dt>Subtotal</dt>
                        <dd>{{ currency( basket.subtotal ) }}</dd>

                        <dt>Delivery</dt>
                        <dd>{{ currency( basket.shipping ) }}</dd>

                        <dt class="is-bold">Total</dt>
                        <dd class="is-bold">{{ currency( basket.total ) }}</dd>
                    </dl>

                    <div class="buttons">
                        <button type="button" class="button" v-on:click="$root.closeBasket">Continue shopping</button>
                        <router-link :to="{ name: 'checkout' }" class="button is-primary" :disabled="basket.saving" :class="{ 'is-loading': basket.saving }">Proceed to checkout</router-link>
                    </div>
                </footer>
            </template>
            <p v-else class="no-items">No items in your basket.</p>
        </div>
    </aside>
</template>

<script>
    import currency from '../support/Currency';
    import session from '../support/Session';

    export default
    {
    	computed:
        {
            basket()
            {
            	return this.session.basket;
            }
        },
        data()
        {
            return { session };
        },
        methods:
        {
	        currency,
        }
    };
</script>
